const TURNSTILE_EXCLUDED_ROUTE_PREFIXES = ["/map", "/giving-tuesday/map", "/wallet-pass"];

export const isTurnstileExcludedRoute = (pathname: string): boolean =>
  TURNSTILE_EXCLUDED_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
